<template>
  <div id="modal-count" ref="modal-count" v-if="modalCounting">
    <div class="background-counting">
        <h1>Time: {{timeout}}</h1>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      modalCounting: "layout/modalCounting",
      timeout: "summer-trip-vote/timeout"
    }),
  },
  created() {
  },
  methods: {
     ...mapActions("layout", ["setLoading", "setCounting"]),
     

  },
};
</script>

<style lang="scss" scoped>
#modal-count {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: red;
  opacity: 0.8;
  z-index: 9999;
  margin: 0 auto;
}
.background-counting {
    position: absolute;
    top: 50%;
    left: 50%;
}
</style>